/* eslint-disable no-useless-computed-key */
/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import clsx from "clsx";
import { Box, Typography, TextField } from "@mui/material";
import { NavLink } from "react-router-dom";
import { capitalizeFirstLetter } from "../../../../../helpers/utilities";
import SearchIcon from "../../../../../assets/images/icon_actions/Search Icon.svg";
import RefreshIcon from "../../../../../assets/images/refresh.svg";
import { Col, Image, Row, Space } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";
import { MyproductList } from "./MyproductList";
import { PrimaryDrawer } from "../../../../Shared/components/Drawer/PrimaryDrawer";
import younoteAdminActions from "../../../../YounoteAdmin/Product/redux/actions";
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard";
import { myProductHeadProduct, myProductHeadProductPrev } from "../../../../../config/constant";
import usePrevious from "../../../../Shared/components/Previous";
import crudActions from "../../../../CRUD/redux/actions";
import { toast } from 'react-toastify';
import CustomAlert from "../../../../Shared/components/CustomAlert";
import dayjs from 'dayjs';
import moment from 'moment';

export const MyProductView = (props) => {
    const classes = customStyles();
    const { createDetails, createError, createLoader, getData, createData, } = useSelector(state => state.crudReducer);
    const { productDetails, brandDetails } = useSelector(state => state.younoteAdminProductReducer);
    const { customCatalogue, history, categoryDetails, loadChilderTasks } = props;
    const timeoutRef = useRef(null);
    const prevCreateDetails = usePrevious(createDetails);
    const prevCreateError = usePrevious(createError);
    const [sortOrder, setSortOrder] = useState("desc");
    const [sortBy, setSortBy] = useState("productId");
    const [iconAnimation, setIconAnimation] = useState(false);
    const [search, setSearch] = useState('');
    const [categoryDropDown, setCategoryDropDown] = useState([{}]);
    const [selected, setSelected] = useState([]);
    const [useMrp, setUseMrp] = useState(false);
    const [visible, setVisible] = useState(false);
    //const [modalVisible, setModalVisible] = useState(false);
    const [productList, setProductList] = useState([]);
    const [form, setForm] = useState({});
    const [lastData, setLastData] = useState([]);
    const [loadMore, setLoadMore] = useState(false);
    const [preview, setPreview] = useState(false);
    const prevSearch = usePrevious(search);
    const [commonError, setCommonError] = useState(false);
    const [duplicates, setDuplicates] = useState(false);
    const [brandId, setBrandId] = useState('');
    const dispatch = useDispatch();

    const customObject = (details, id) => {
        let a = details && details.filter(function (el) { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    const onView = (data) => {
        setVisible(true);
        setForm({
            "productName": data?.productName,
            "description": data?.description !== null && data?.description !== '' ? data?.description : '',
            "type": data?.type,
            "productId": data?.productId,
            "catalogueId": data?.catalogue?.catalogueName,
            "categoryId": data?.category?.categoryName,
            "hsnId": data?.hsn?.hsnCode,
            "productGstId": data?.productGst?.code,
            "skuUnitId": data?.skuUnit?.name,
            "salesUnitId": data?.salesUnit?.name,
            "skuQuantity": parseInt(data?.skuQuantity),
            "status": data?.status,
            "mrp": data?.mrp,
            "barcode": data?.barcode || '',
            'ianNumber': data?.ianNumber || '',
            "priceIncludesTax": data?.priceIncludesTax,
            "latestPurchasePrice": data?.latestPurchasePrice || '',
            "latestPurchasePriceTs": data?.latestPurchasePriceTs ? dayjs(data?.latestPurchasePriceTs).$d : '',
            "mrpLastUpdatedDate": data?.mrpLastUpdatedDate ? dayjs(data?.mrpLastUpdatedDate).$d : '',
        });
        setUseMrp(data?.useMrp);
    }


    useEffect(() => {
        if (prevCreateDetails !== undefined && createDetails && prevCreateDetails !== createDetails) {
            if (duplicates) {
                if (createData?.duplicates?.length > 0) {
                    toast.dismiss();
                    toast.error(`Marked items contains ${createData?.duplicates?.length} Duplicates`);
                    setDuplicates(false);
                    setTimeout(() => {
                        let error = document.querySelectorAll(`.${classes.colorRed}`);
                        if (error.length > 0) {
                            if (error[0].closest('.MuiTableRow-root').previousSibling) {
                                error[0].closest('.MuiTableRow-root').previousSibling.scrollIntoView({ behavior: 'smooth', block: 'start' });
                            }
                        }
                    }, 100);
                } else {
                    setPreview(true);
                }
            } else {
                toast.dismiss();

                //toast(`Client Products has been added successfully`);
                history.push(`/product/product/my-products/`, 'catalogue');
            }
        } else if (prevCreateError !== undefined && createError && prevCreateError !== createError) {
            let error = createError.error.message;
            setCommonError(error);
        }
    }, [createDetails, createError]);


    useEffect(() => {
        if ((prevSearch !== undefined && search && search.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                dispatchFilter(lastData, sortBy, sortOrder);
            } else {
                timeoutRef.current = setTimeout(() => {
                    timeoutRef.current = null;
                    dispatchFilter(lastData, sortBy, sortOrder);
                }, 500);
            }
        }
    }, [search]);

    const changeHandler = (data) => {
        if (data?.id) {
            const selectedIndex = categoryDropDown.findIndex((el) => el?.id === data?.parentId);
            categoryDropDown[selectedIndex + 1] = data;
            setProductList([]);
            setBrandId('');
            if (data?.hasSubCategories) {
                categoryDropDown[selectedIndex + 2] = {};
                categoryDropDown.length = selectedIndex + 3;
                dispatch({
                    type: crudActions.GET_DETAILS_START,
                    url: `/get-subcategories/${data?.id}`,
                });
            } else {
                categoryDropDown.length = selectedIndex + 2;
                setLastData([data.id]);
                dispatchFilter([data.id], sortBy, sortOrder);
                setLoadMore(false);
            }
            setCategoryDropDown([
                ...categoryDropDown
            ]);
            setSelected([]);
        }
    }

    useEffect(() => {
        setLoadMore(true);
        setProductList(productDetails);
    }, [productDetails]);

    const handleClick = (id) => {
        const selectedIndex = selected.indexOf(id);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }
        setSelected(newSelected);
    }

    useEffect(() => {
        if (selected.length === 0) {
            setPreview(false)
        }
    }, [selected]);

    useEffect(() => {
        setCommonError('');
    }, [preview]);

    const handleFindProducts = () => {
        let lastElement = categoryDropDown[categoryDropDown.length - 1];
        if (lastElement?.id === undefined) {
            let d = categoryDropDown[categoryDropDown.length - 2];
            let dList = categoryDetails && categoryDetails.filter((el) => { return el.parentId === d?.id });
            let cIds = [d?.id];
            if (dList.length > 0) {
                getData?.length > 0 && getData?.map((item) => {
                    item["1evel3"] && item["1evel3"]?.map((item) => {
                        item["1evel4"] && item["1evel4"]?.map((item) => {
                            cIds.push(item.id);
                        });
                        cIds.push(item.id);
                    });
                    cIds.push(item.id);
                });
                dispatch({
                    type: younoteAdminActions.PRODUCT_DETAILS_START,
                    //  url: `getAllUniversalProductsByCategoryId/${d.id}`,
                    filter: {
                        where: { ["and"]: [{ categoryId: { inq: cIds } }, { catalogueId: customCatalogue?.id }, { status: 'ACTIVE' }] },
                        order: "id desc"
                    }
                });
                setLastData(cIds);
                setLoadMore(false);
            }
        }
    }

    const requestSort = (sortBy, sortOrder) => {
        setSortBy(sortBy);
        setSortOrder(sortOrder);
        dispatchFilter(lastData, sortBy, sortOrder);
    }


    const dispatchFilter = (data, sortBy, sortOrder) => {
        let filter = '';
        if (data && data?.length > 0) {
            filter = { ["and"]: [{ categoryId: { inq: data } }, { catalogueId: customCatalogue?.id }, { status: 'ACTIVE' }] };
        } else {
            filter = { ["and"]: [{ catalogueId: customCatalogue?.id }, { status: 'ACTIVE' }] };
        }

        let or = { ["or"]: [] };
        if (search !== '') {
            or['or'].push({ productName: { like: '%' + search.trim() + '%' } });
            or['or'].push({ productId: { like: '%' + search.trim() + '%' } });
            or['or'].push({ description: { like: '%' + search.trim() + '%' } });
            or['or'].push({ skuQuantity: { like: '%' + search.trim() + '%' } });
            or['or'].push({ status: { like: '%' + search.trim() + '%' } });
            or['or'].push({ type: { like: '%' + search.trim() + '%' } });
        }
        filter['and'].push(or);
        dispatch({
            type: younoteAdminActions.PRODUCT_DETAILS_START,
            filter: {
                order: sortBy + ' ' + sortOrder,
                where: filter
            }
        });
    }

    const handleAddUniversalProduct = () => {
        setDuplicates(false);
        dispatch({
            type: crudActions.CREATE_DETAILS_START,
            url: "create-client-products-from-universal-products",
            title: "Client Products",
            details: { 'universalProductIdList': selected }
        });
    }

    const handleDuplicates = () => {
        setDuplicates(true);
        dispatch({
            type: crudActions.CREATE_DETAILS_START,
            url: "check-client-products-duplicates",
            title: "Client Products",
            details: { 'universalProductIdList': selected }
        });
    }

    const handleRefresh = () => {
        loadChilderTasks();
        setCategoryDropDown([{}]);
        setBrandId('');
        setLoadMore(false);
    }

    const changeBrandHandler = (data) => {
        setCategoryDropDown([{}]);
        setBrandId(data?.id);
        dispatch({
            type: younoteAdminActions.PRODUCT_DETAILS_START,
            filter: {
                where: { ["and"]: [{ brandId: data?.id }, { catalogueId: customCatalogue?.id }, { status: 'ACTIVE' }] },
                order: 'id desc'
            }
        });
        setLoadMore(false);
    }

    return (
        <>
            {
                preview ? <div className={clsx(classes.margin40, classes.listTableMargin)}>
                    <PrimaryCard
                        title={'Preview'}
                        component={
                            <>
                                <Row align="middle" className={classes.marginBottom20}>
                                    <Col span={14}>
                                        {
                                            commonError && <CustomAlert error={commonError} customClass={clsx(classes.uploadError)} />
                                        }
                                    </Col>
                                    <Col span={10} className={classes.textAlignRight}>
                                        <Space direction="horizontal" align="center" size={[10, 10]}>
                                            <NavLink to={'#'}
                                                onClick={() => setPreview(false)}
                                                className={clsx(classes.AddMoreBtn)}
                                            >Go to previous</NavLink>
                                            <NavLink
                                                to={"#"}
                                                onClick={() => handleAddUniversalProduct()}
                                                className={clsx(classes.modalBtn, { [classes.loadingA]: createLoader })}>Add
                                            </NavLink>
                                        </Space>
                                    </Col>
                                </Row>
                                <MyproductList
                                    details={productList.filter((el) => { return selected.find(e => e === el.id) })}
                                    loadMore={true}
                                    heads={myProductHeadProductPrev}
                                    selected={selected}
                                    checkbox={false}
                                    onView={(data) => onView(data)}
                                    duplicates={[]}
                                    onSelected={(value) => { setSelected(value); }}
                                    handleClick={(id) => handleClick(id)}
                                />
                            </>
                        }
                    />
                </div> :
                    <div className={clsx(classes.margin40, classes.listTableMargin, classes.listTableMargin)}>
                        <Row gutter={10}>
                            <Col span={5}>
                                <PrimaryCard
                                    title={'Fillter'}
                                    component={
                                        <Box className={clsx(classes.removeUnderline)} style={{ height: "100%" }} component="div">
                                            {
                                                ((categoryDropDown && categoryDropDown?.length > 0 && categoryDropDown[0]?.id) || brandId) ? <NavLink to={'#'} onClick={() => handleRefresh()} className={clsx(classes.margin10t, classes.customLink, classes.PaddingRight15, classes.bold, classes.textAlignRight, classes.cursor)}>
                                                    <Image src={RefreshIcon} className={classes.catalogueRefresh} preview={false} /> <span>Filter Reset</span></NavLink> : <NavLink to={'#'} variant={'h6'} className={clsx(classes.margin10t, classes.disabled, classes.PaddingRight15, classes.customLink, classes.bold, classes.textAlignRight, classes.cursor)}>
                                                    <Image src={RefreshIcon} className={classes.catalogueRefresh} preview={false} /> <span>Filter Reset</span></NavLink>
                                            }
                                            <Typography variant={'h6'} className={clsx(classes.fonSize14, classes.bold, classes.margin25t)}><span>{customCatalogue?.catalogueName}</span>
                                            </Typography>


                                            <div className={classes.categoryDropDownScroll}>
                                                {
                                                    brandId === '' && <>
                                                        <Typography variant={'h6'} className={clsx(classes.addressSmall, classes.margin15t, classes.bold)}><span>Filter By Category</span>
                                                        </Typography>
                                                    </>
                                                }
                                                {
                                                    brandId === '' && categoryDropDown.length > 0 && categoryDropDown.map((data, i) => (
                                                        <AutoCompleteComponent
                                                            customLabel={i === 0 ? "Please Select Category" : `Please Select Sub Category-${i}`}
                                                            heads={[{ 'key': 'categoryName', 'name': 'Name' },
                                                            { 'key': 'categoryPrefix', 'name': 'Prefix' }]}
                                                            details={i > 0 ? categoryDetails.filter((el) => { return el.parentId === categoryDropDown[i - 1]?.id }) : categoryDetails.filter((el) => { return el.catalogueId === customCatalogue?.id && el.parentId === null })}
                                                            parentValue={customObject(categoryDetails, data?.id)}
                                                            position={"top"}
                                                            variant={'outlined'}
                                                            customClasses={clsx(classes.margin20t)}
                                                            onChange={(data) => changeHandler(data)}
                                                        />
                                                    ))
                                                }
                                                {
                                                    categoryDropDown[0]?.id === undefined && <>
                                                        <Typography variant={'h6'} className={clsx(classes.addressSmall, classes.bold, classes.disInline, { [classes.margin35t]: brandId === '' })}><span>Filter By Brand</span>
                                                        </Typography>
                                                        {
                                                            <AutoCompleteComponent
                                                                customLabel={'Please Select Brand'}
                                                                heads={[{ 'key': 'brandName', 'name': 'Name' },
                                                                { 'key': 'brandShortName', 'name': 'Short Name' }]}
                                                                details={brandDetails}
                                                                parentValue={customObject(brandDetails, brandId)}
                                                                position={"top"}
                                                                variant={'outlined'}
                                                                customClasses={classes.margin20t}
                                                                onChange={(data) => changeBrandHandler(data)}
                                                            />
                                                        }
                                                    </>
                                                }
                                            </div>
                                            {
                                                categoryDropDown[0]?.id && <NavLink to={'#'}
                                                    onClick={() => handleFindProducts()}
                                                    className={clsx(classes.AddMoreBtn, classes.margin15r, classes.cardAddMoreBtn, { [classes.disabled]: categoryDropDown[categoryDropDown.length - 1]?.id !== undefined })}
                                                >Apply</NavLink>
                                            }
                                        </Box>
                                    }
                                />
                            </Col>
                            <Col span={19}>
                                <PrimaryCard
                                    title={'Products'}
                                    component={
                                        <>
                                            <Row align="middle" className={classes.marginBottom20}>
                                                <Col xxl={6} xl={7} lg={8} md={10} sm={13} xs={24}>
                                                    <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation })}>
                                                        <TextField autoComplete='one-time-code'
                                                            placeholder='Search'
                                                            type='search'
                                                            className={classes.comInput}
                                                            required
                                                            variant={'standard'}
                                                            onChange={(e) => setSearch(e.target.value)}
                                                            fullWidth
                                                            onFocus={() => setIconAnimation(true)}
                                                            onBlur={() => setIconAnimation(false)}
                                                        />
                                                        <Image
                                                            src={SearchIcon}
                                                            preview={false}
                                                        />
                                                    </div>
                                                </Col>
                                                <Col xxl={18} xl={17} lg={16} md={14} sm={11} xs={24} className={classes.textAlignRight}>
                                                    <Space direction="horizontal" align="center" >
                                                        {/* <NavLink to={`#`} onClick={() => handleParentClick('catalogue', customCatalogue)}
                                                            className={clsx(classes.AddMoreBtn)}>{customCatalogue?.catalogueName}</NavLink> */}
                                                        <NavLink to={`#`} onClick={() => setSelected([])}
                                                            className={clsx(classes.AddMoreBtn, { [classes.disabled]: selected.length === 0 })}>Unselect {selected && selected.length > 0 && `(${selected.length})`}</NavLink>
                                                        <NavLink to={`#`} onClick={() => handleDuplicates()}
                                                            className={clsx(classes.modalBtn, { [classes.disabled]: selected.length === 0 })}>Next</NavLink>
                                                    </Space>
                                                </Col>
                                            </Row>
                                            <MyproductList
                                                details={productList}
                                                loadMore={loadMore}
                                                selected={selected}
                                                checkbox={true}
                                                sortOrder={sortOrder}
                                                sortBy={sortBy}
                                                heads={myProductHeadProduct}
                                                onView={(data) => onView(data)}
                                                onSelected={(value) => { setSelected(value); }}
                                                handleClick={(id) => handleClick(id)}
                                                duplicates={createData?.duplicates || []}
                                                onRequestSort={(sortBy, sortOrder) => requestSort(sortBy, sortOrder)}
                                            />
                                        </>
                                    }
                                />
                            </Col>
                        </Row>
                    </div >
            }
            <PrimaryDrawer
                anchor={'right'}
                open={visible}
                variant={'temporary'}
                handleClose={() => setVisible(false)}
                title={`View Product`}
                width={'495px'}
                className={classes.closeBackGround}
                component={
                    <Box

                        className={clsx(classes.customForm, classes.removeUnderline)}
                        component="div">
                        <div className={classes.customFormFlex}>
                            <Row type="flex" gutter={40} className={clsx(classes.margin30t)}>
                                <Col span={16}>
                                    <Row type="flex">
                                        <Col span={24}>
                                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.bold, classes.fonSize14)}>{form.productName}</Typography>
                                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.margin5t, classes.fonSize13)}>{form.productId}</Typography>
                                        </Col>
                                        <Col span={24}>
                                            <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Description</Typography>
                                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form.description}</Typography>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col span={8} style={{ height: "100%" }}>
                                    <div className={clsx(classes.productImageUpload)}>
                                        <div className={classes.productImageUploadInner}>
                                            <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Product Image</Typography>
                                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{'---'}</Typography>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            <Row type="flex" gutter={40}>
                                <Col span={8}>
                                    <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Catalogue Name</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.catalogueId || '---'}</Typography>
                                </Col>
                                <Col span={8}>
                                    <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Category Name</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.categoryId || '---'}</Typography>
                                </Col>
                                <Col span={8}>
                                    <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Product Type</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.type ? capitalizeFirstLetter(form?.type) : '---'}</Typography>
                                </Col>
                                <Col span={8}>
                                    <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>SKU Quantity</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form.skuQuantity}</Typography>
                                </Col>
                                <Col span={8}>
                                    <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>SKU Unit</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.skuUnitId || '---'}</Typography>
                                </Col>
                                <Col span={8}>
                                    <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Sales Unit</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.salesUnitId || '---'}</Typography>
                                </Col>
                                <Col span={8}>
                                    <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Product GST Code</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.productGstId || '---'}</Typography>
                                </Col>
                                <Col span={8}>
                                    <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Status</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{capitalizeFirstLetter(form.status)}</Typography>
                                </Col>
                                <Col span={8}>
                                    <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>HSN Code</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.hsnId || '---'}</Typography>
                                </Col>
                                <Col span={8}>
                                    <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Bar Code</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.barcode || '---'}</Typography>
                                </Col>
                                <Col span={8}>
                                    <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>IAN Number</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.ianNumber || '---'}</Typography>
                                </Col>
                                <Col span={24}>
                                    <Space className={clsx(classes.customLink, classes.margin20t)}>
                                        <Typography variant={'h6'} className={clsx(classes.typographyHeader, classes.bold)}>Prices</Typography>
                                    </Space>
                                </Col>
                                <Col span={8}>
                                    <Typography variant={'subtitle1'} className={clsx(classes.margin10t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Use MRP</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{useMrp ? 'Yes' : 'No'} </Typography>
                                </Col>
                                <Col span={8}>
                                    <Typography variant={'subtitle1'} className={clsx(classes.margin10t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>MRP</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.mrp || '---'}</Typography>
                                </Col>
                                <Col span={8}>
                                    <Typography variant={'subtitle1'} className={clsx(classes.margin10t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Price Includes Tax</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form.priceIncludesTax ? 'Yes' : 'No'} </Typography>
                                </Col>
                                <Col span={8}>
                                    <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Latest Updated Date (MRP)</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                        {form.mrpLastUpdatedDate ? moment(form.mrpLastUpdatedDate).format('DD MMM YYYY') : '---'}
                                    </Typography>
                                </Col>
                            </Row>
                        </div>
                    </Box>
                }
            />
        </>

    );
}